import create from 'zustand';
import { shopModel, teleConsultationModel } from '../Axios/AxiosConfig';
import axios from 'axios';
import { getUserDetails } from '../Auth/AuthUtil';
import { encryptBody } from '../Axios/Middleware';

const useCartStore = create((set, get) => ({
    cartItems: [],
    Coupons: null,
    isCartLoading: true,
    CompanyCodedetails: false,
    CouponDetails: null,
    CouponErrorDetails: null,
    CompanyCodeErrdetails: null,
    deliveryCharges: 0,

    addItem: async (item, userId) => {
        try {
            const response = await shopModel.post('/api/v1/Addtocart', encryptBody({ userId, item }, { includeIv: false }));
            if (response.status === 200) {
                set((state) => ({
                    cartItems: response.data.items,
                    deliveryCharges: response?.data?.deliverycharges
                }));
            }
        } catch (error) {
            console.log(error.response.data);
        }
    },

    removeItem: async (id) => {
        try {
            const userId = getUserDetails()?.UID
            const response = await shopModel.delete(`/api/v1/cart/items/${id}`);
            if (response.status === 200) {
                set((state) => ({
                    cartItems: response.data.items,
                    deliveryCharges: response?.data?.deliverycharges
                }));
            }
        } catch (error) {
            console.error('Error removing item from cart:', error);
        }
    },

    getCart: async () => {
        try {
            const userId = getUserDetails()?.UID
            const response = await shopModel.get(`/api/v1/cart`)
            if (response?.status === 200) {

                set((state) => ({
                    cartItems: response?.data?.items,
                    isCartLoading: false,
                    deliveryCharges: response?.data?.deliverycharges
                }));
            }
        }
        catch (err) {
            if (err?.response?.status === 404) {
                set({
                    isCartLoading: false,
                })
            }
            console.error('Error removing item from cart:', err);
        }
    },

    clearCart: async () => {
        try {
            const res = await shopModel.delete(`/api/v1/cart`)
            if (res.status === 200) {
                set({
                    cartItems: [],
                    deliveryCharges: res?.data?.deliverycharges
                })
            }
        }
        catch (err) {
            console.log(err?.response?.data)
        }

    },

    emptyCart: async () => {
        set({
            cartItems: []
        })
    },

    setDeliveryCharge: (data) => set({ deliveryCharges: data }),

    setCouponDetails: (data) => set({ CouponDetails: data }),

    AvailCoupon: async (coupon, applicableTo, total) => {
        try {
     
            const res = await shopModel.post('/api/v1/avail-coupon', {
                coupon,
                applicableTo,
                total
            })

            if (res.status === 200) {
                set({
                    CouponDetails: res.data
                })
            }

        }

        catch (err) {

            set({
                CouponErrorDetails: err?.response?.data
            })

            console.log(err)
        }

    },

    AvailCompanyCode: async (coupon, total) => {
        try {
            const userId = getUserDetails()?.UID

            const res = await teleConsultationModel.post('/AvailCompanyCode', {
                coupon,
                total
            })

            if (res.status === 200) {
                set({
                    CouponDetails: res.data
                })
            }

        }

        catch (err) {

            set({
                CouponErrorDetails: err?.response?.data
            })

            console.log(err)
        }

    },

    getCompanyCoupondetails: async () => {
        try {

            const userId = getUserDetails()?.UID

            const res = await teleConsultationModel.post('/getCorporateUserDetails', {
                UID: userId
            })

            if (res.status === 200) {
                set({
                    CompanyCodedetails: res?.data,
                    CompanyCodeErrdetails: null
                })
            }

        }

        catch (err) {
            set({
                CompanyCodeErrdetails: err.response.data
            })

            console.log(err.response.data)
        }
    },

    setCouponError: (data) => set({ CouponErrorDetails: data }),

    setCompanyCoupondetails: (data) => set({ CompanyCodedetails: data }),

    updateQuantity: async (id, userId) => {

        const state = get();

        const item = state.cartItems.find(item => item.id === id);

        if (item && item?.quantity >= 1) {
            const newQuantity = item?.quantity + 1;
            try {
                const response = await shopModel.put(`api/v1/cart/items/${id}`, encryptBody({ id, newQuantity }, { includeIv: false }));
                if (response.status === 200) {
                    set((state) => ({
                        cartItems: response.data.items,
                        deliveryCharges: response?.data?.deliverycharges
                    }));
                }
            } catch (error) {
                console.error('Error decreasing item quantity:', error.response.data);
            }
        }
    },

    getCouponDetails: async (availableTo, totalAmount) => {
        try {

            const res = await shopModel.post('/api/v1/get-available-coupons', {
                availableTo,
                totalAmount
            });

            if (res.status && res.data) {
                set({ Coupons: res?.data });
            }

        } catch (err) {
            console.error(err?.response?.data);
        }
    },

    decreaseQuantity: async (id, userId) => {
        const state = get();

        const item = state.cartItems.find(item => item.id === id);

        if (item && item.quantity > 1) {
            const newQuantity = item.quantity - 1;
            try {
                const response = await shopModel.put(`/api/v1/cart/items/${id}`, encryptBody({ id, newQuantity }, { includeIv: false }));

                if (response.status === 200) {
                    set((state) => ({
                        cartItems: response.data.items,
                        deliveryCharges: response?.data?.deliverycharges
                    }));
                }

            } catch (error) {
                console.error('Error decreasing item quantity:', error.response.data);
            }
        }
    },

    totalPrice: () => {
        const cartItems = get().cartItems;

        // const existingItem = cartItems.find(cartItem => cartItem.companyid === '1006');

        // if (existingItem) {
        //     set({ deliveryCharges: existingItem.deliverycharges });
        // } else {
        //     set({ deliveryCharges: 0 });
        // }

        const total = cartItems.reduce((total, item) => {
            return total + item.price * item.quantity;
        }, 0);

        return total;
    },

}));

export default useCartStore;
